import React, { Component as C } from "react"
import PropTypes from "prop-types"

class TipV2 extends C {
  static propTypes = {
    className: PropTypes.string,
    tipText: PropTypes.string,
  }

  render() {
    let { tipText, className } = this.props

    return <div className={className}>{tipText}</div>
  }
}

export default TipV2
